import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'widget',
    targetSelector: '.module',
    property: 'data-widget',
    options: [
      {
        key: 'carousel',
        value: 'Carousel',
      },
      {
        key: 'allReviews',
        value: 'All Reviews',
      },
    ],
    links:
      'onlyShowImg, useWidgetFont, showMore, dotColor, arrowsColor, ratingsLimit, onlyShowImg, showProductThumbnail, selectProduct',
    default_value: 'carousel',
  },
  {
    type: 'html:attr',
    name: 'ratingsLimit',
    refreshType: 'all',
    targetSelector: '.module > .loox-reviews-default',
    property: 'data-limit',
    default_value: '10',
  },
  {
    type: 'html:attr',
    name: 'onlyShowImg',
    refreshType: 'all',
    targetSelector: '.module > .loox-reviews-default',
    property: '',
    default_value: '0',
  },
  {
    type: 'html:attr',
    name: 'showProductThumbnail',
    refreshType: 'all',
    targetSelector: '.module > .loox-reviews-default',
    property: 'data-product-thumbnails',
    default_value: '0',
  },
  {
    type: 'html:attr',
    name: 'selectProduct',
    refreshType: 'all',
    targetSelector: '.module > .loox-reviews-default',
    property: '',
    default_value: '0',
    links: 'product',
  },
  //advanced options
  {
    type: 'html:attr',
    name: 'useWidgetFont',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-use-widget-font',
    default_value: 'false',
  },
  {
    type: 'html:attr',
    name: 'showMore',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-show-more',
    default_value: '0',
    links: 'buttonColor',
  },
  {
    type: 'html:attr',
    name: 'buttonColor',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-button-color',
    default_value: 'none',
  },
  {
    type: 'html:attr',
    name: 'dotColor',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-dot-color',
    default_value: 'none',
  },
  {
    type: 'html:attr',
    name: 'arrowsColor',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-arrows-color',
    default_value: 'none',
  },
  {
    type: 'html:attr',
    name: 'pid',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-product-ids',
    default_value: 'auto',
  },
  {
    type: 'html:attr',
    name: 'pHandle',
    refreshType: 'all',
    targetSelector: '.module',
    property: '',
    default_value: 'auto',
  },
  {
    type: 'html:attr',
    name: 'product',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-product-ids',
    default_value: 'Auto',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Loox Carousel/ Homepage Widget Atom Module
 */
export class GpLooxCarousel extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Loox Carousel/HomePage Widget';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'loox-reviews-carousel';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
